import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Facet, FacetOption, FilterService } from '@lobos/library';
import { UntypedFormControl } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-product-facet-item',
  templateUrl: './product-facet-item.component.html',
  styleUrls: ['./product-facet-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProductFacetItemComponent implements OnInit {
  @Input() facet!: Facet;
  @Input() resetSelection$!: Observable<boolean>;
  facetFC = new UntypedFormControl();
  @Output() facetChanged = new EventEmitter<FacetOption>();

  constructor(public filterService: FilterService) {}

  ngOnInit() {
    this.resetSelection$
      .pipe(
        tap((x) => {
          if (x) {
            this.facetFC.setValue([]);
          }
        }),
        untilDestroyed(this),
      )
      .subscribe();

    const activeFilters = this.filterService
      .getFilters()
      .filter((x) => x.name === this.facet?.key)
      .map((x) => x.id.toString().substring(this.facet.key.length + 1));
    this.facetFC.setValue(activeFilters, { emitEvent: false, emitModelToViewChange: false, emitViewToModelChange: false, onlySelf: true });
  }

  /** used to track ngFor loop of options */
  trackByFn(_: number, item: FacetOption) {
    return item.key;
  }

  onSelectionChange(option: FacetOption, event: MatOptionSelectionChange) {
    if (event.isUserInput) {
      if (option.isActive) {
        this.filterService.removeFilterWithParam(option.key, this.facet.key);
      } else {
        this.filterService.setFilter({
          id: `${this.facet.key}_${option.key}`,
          name: this.facet.key,
          value: option.key,
          order: 1,
        });
      }
    }
    this.facetChanged.emit(option);
  }
}
